import axios from "vue-app/utils/axios";

async function onLangChange(option: { value: string; name: string }) {
  try {
    await axios.post("/account/language/save", {
      language: option.value,
    });
    location.reload();
  } catch (error) {
    alert("Cannot change the language");
  }
}

async function handleClickRegular() {
  try {
    await axios.post("/account/update_is_dev", {
      isDev: "false",
    });
    location.reload();
  } catch (error) {
    alert("Cannot change the isDev flag");
  }
}

async function handleClickDev() {
  try {
    await axios.post("/account/update_is_dev", {
      isDev: "true",
    });
    location.reload();
  } catch (error) {
    alert("Cannot change the isDev flag");
  }
}

async function handleClickSendVerifyEmail() {
  try {
    await axios.post("/resend_agent_email_confirmation_email");
    window.showToast(window._trans._notifications.confirmations.emailVerification.success, "success");
  } catch (error) {
    window.showToast(window._trans._notifications.confirmations.emailVerification.error, "error");
  }
}

function changeWorkspace(trackerId: number) {
  try {
    const form = document.createElement("form");
    const element = document.createElement("input");

    form.method = "POST";
    form.action = "/account/set_current_tracker";
    element.value = trackerId.toString();
    element.name = "tracker_id";
    element.id = "tracker_id";
    element.type = "hidden";

    form.appendChild(element);
    document.body.appendChild(form);
    form.submit();
  } catch (error) {
    window.showToast("Something went wrong, couldn't change workspace", "error");
  }
}

async function updateUserNewMenu(value: boolean) {
  await axios.post("/account/updateNewMenu", {
    value: value,
  });
}

export {
  onLangChange,
  handleClickDev,
  handleClickRegular,
  handleClickSendVerifyEmail,
  changeWorkspace,
  updateUserNewMenu,
};
